import { render, staticRenderFns } from "./PendingSalesPage.vue?vue&type=template&id=1cc82d97&scoped=true&"
import script from "./PendingSalesPage.vue?vue&type=script&lang=js&"
export * from "./PendingSalesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc82d97",
  null
  
)

export default component.exports